// 支付
import {
  basePost
} from '../utils/request';

// 支付订单
export function payment(data) {
  return basePost('/payment/payment', data)
}
// 获取支付订单状态
export function getOrder(data) {
  return basePost('/payment/getOrder', data)
}
// 订单列表
export function getOrderList(data) {
  return basePost('/payment/getOrderList', data)
}
// 每天采集次数判断
export function getPaymentCheck(data) {
  return basePost('/payment/getPaymentCheck', data)
}
// 扣款记录
export function getConsumeList(data) {
  return basePost('/payment/getConsumeList', data)
}
// 获取每天采集次数
export function getUserCheckNum(data) {
  return basePost('/payment/getUserCheckNum', data)
}

// 获取每天采集次数
export function getDishonestyPaymentList(data) {
  return basePost('/black/getConsumeList', data)
}